import { sendStats, STATS_EVENTS } from '../helpers/sendStats';
import { AddressResponse } from '../@types/address';
import { SPECIAL_HEADERS } from '../constants/api';

export type GetAddressParams = {
  query: string;
  houseOnly?: boolean;
  signal?: AbortSignal;
};
const fetchAddressList = ({
  query,
  houseOnly = false,
  signal,
}: GetAddressParams): Promise<AddressResponse> => {
  const encodedQuery = encodeURIComponent(query.replace(/\//g, ' '));
  const encodedHouseOnly = houseOnly ? `&house_only=1` : '';
  return fetch(`/aisearch/hwsuggest/api/v1/suggest/?q=${encodedQuery}${encodedHouseOnly}`, {
    headers: {
      [SPECIAL_HEADERS.CALLER_ID_KEY]: SPECIAL_HEADERS.CALLER_ID_VALUE,
    },
    credentials: 'same-origin',
    signal,
  }).then((response) => response.json());
};

export const getAddressList = async (params: GetAddressParams) => {
  const timeStart = Date.now();
  const { suggests = [] } = await fetchAddressList(params);
  const timeEnd = Date.now();
  const requestTime = timeEnd - timeStart;
  sendStats(STATS_EVENTS.GET_ADDRESS_REQUEST_TIME, requestTime);
  return suggests.slice(0, 10);
};
